import { Link } from "react-router";
import css from "./UserBar.module.css";
import { AuthUser } from "~/auth.server";
import { LinkButton } from "./links/LinkButton";
import { UserLink } from "./UserLink";

export function UserBar(props: { authUser: AuthUser | null }) {
  const { authUser } = props;
  return (
    <div className={css.root}>
      {authUser ? (
        <div className={css.control}>
          <div className={css.username}>
            <UserLink
              user={{
                id: authUser.id,
                name: authUser.login,
                avatar: authUser.avatar,
              }}
            />
          </div>
          <div className={css.dropdownMenu} id="dropdown-menu1" role="menu">
            <div className={css.dropdownContent}>
              <Link className={css.dropdownItem} to={"/profile"}>
                Profile
              </Link>
              <Link className={css.dropdownItem} to={"/logout"}>
                Logout
              </Link>
            </div>
          </div>
          <div className={css.mobileLogout}>
            <LinkButton to="/Logout" color="gray">
              Logout
            </LinkButton>
          </div>
        </div>
      ) : (
        <div className={css.authLinks}>
          <LinkButton to="/login" color="gray">
            Login
          </LinkButton>{" "}
          <LinkButton to="/register" color="red">
            Register
          </LinkButton>
        </div>
      )}
    </div>
  );
}
